import { useCallback } from 'react'

const useCheckConditionalReason = ({
  activeCount,
  partSelection,
  selectedPartInfo,
  merchantOrderId,
  setPreserveReason,
  setOptionsToHide,
  setData,
  allowMechanicDiagnosis,
  selectedPartETA,
  isHassleFree,
}) => useCallback(
  dataResponse => {
    const tempRespData = dataResponse
    const optionsToHideTemp = []
    const counterCheck = activeCount || 0
    const {
      actual_delivery_date: actualDeliveryDate,
    } = partSelection[parseInt(counterCheck, 10)] || {}
    const dateToUse = actualDeliveryDate && actualDeliveryDate !== '0000-00-00' ? actualDeliveryDate : selectedPartInfo.ETA
    const dateNow = new Date()
    const dateEta = new Date(dateToUse)
    const prefixMerchantOrderId = merchantOrderId.substring(0, 3)
    let isConditionalreason = false
    switch (dataResponse.id) {
      case 'wrongItem':
        // Hide 3rd Sub Reason temporarily
        optionsToHideTemp.push(tempRespData.widgets[1].id)
        setPreserveReason(tempRespData.widgets[1].id)
        setOptionsToHide(optionsToHideTemp)
        isConditionalreason = true
        break
      case 'purchaseMistake':
        // If not coming from Site Order
        if (prefixMerchantOrderId === 'CSA' ||
            prefixMerchantOrderId === 'CSB' ||
            prefixMerchantOrderId === 'CSC' ||
            prefixMerchantOrderId === 'CSD'
        ) {
          delete tempRespData.widgets[0]
          setData(tempRespData)
        }
        isConditionalreason = true
        break
      case 'lateDelivery':
        // Display customer error if past ETA
        if (isHassleFree) {
          delete tempRespData.widgets[0]
        } else if (!isHassleFree && (Date.parse(dateNow) > Date.parse(dateEta))) {
          delete tempRespData.widgets[0]
        } else if (!isHassleFree) {
          delete tempRespData.widgets[1]
        }
        setData(tempRespData)
        isConditionalreason = true
        break
      case 'itemDefective':
        // Hide 3rd Sub Reason temporarily
        optionsToHideTemp.push(tempRespData.widgets[1].id)
        optionsToHideTemp.push(tempRespData.widgets[2].id)
        setPreserveReason([
          tempRespData.widgets[1].id,
          tempRespData.widgets[2].id,
        ])
        setOptionsToHide(optionsToHideTemp)
        break
      default:
        isConditionalreason = true
        break
    }
    return isConditionalreason
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [
    allowMechanicDiagnosis,
    partSelection,
    activeCount,
    selectedPartETA,
    merchantOrderId,
    selectedPartInfo,
  ],
)

export default useCheckConditionalReason
